// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__mPWtw","list":"styles_list__fPzTg","inline":"styles_inline__aSWUK"};